import React from 'react'
import PropTypes from 'prop-types'
import canUseDom from '@boltui/utils/src/canUseDom'
import ErrorBoundary from '@boltui/error-boundary'
import { HeaderContext, Fallback } from './components'

/* Express middleware to be consumed within applications */
export { headerMiddleware, headerProxy } from './utils'

/* Header Provider & Context */
export { HeaderProvider, HeaderContext, GetHeaderBundle, GetHeaderStyles } from './components'

const propTypes = {
  miniHeader: PropTypes.bool,
  miniHeaderContent: PropTypes.element,
  routes: PropTypes.shape({
    help: PropTypes.func,
    stores: PropTypes.func,
    search: PropTypes.func,
    megabuttons: PropTypes.arrayOf(PropTypes.func)
  }),
  overrideSearchTerm: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  overrideTrolleyCount: PropTypes.number,
  overrideWishlistCount: PropTypes.oneOfType([PropTypes.number, PropTypes.element]),
  overrideOnSearchSubmit: PropTypes.func,
  onUserInfoLoad: PropTypes.func,
  onCisCookieCreated: PropTypes.func,
  trolleyCountChange: PropTypes.number
}

const defaultProps = {
  miniHeader: false,
  miniHeaderContent: null,
  routes: {},
  overrideTrolleyCount: null,
  overrideWishlistCount: null,
  onUserInfoLoad: () => ({}),
  onCisCookieCreated: () => false,
  trolleyCountChange: 0,
  storeId: 10151,
  langId: 110,
  catalogId: 10001
}

const ArgosHeader = (props) => {
  const Header = global.argosHeaderService && global.argosHeaderService.component

  /* Server side & server side fallback */
  if (!canUseDom()) {
    return (
      <HeaderContext.Consumer>
        {(value) => (value ? <div dangerouslySetInnerHTML={{ __html: value.html }} /> : <Fallback />)}
      </HeaderContext.Consumer>
    )
  }

  /* Client side fallback */
  if (canUseDom() && (!Header || typeof Header !== 'function')) {
    return <Fallback />
  }

  /* Client side */
  return (
    <ErrorBoundary FallbackComponent={<Fallback />}>
      <Header {...props} />
    </ErrorBoundary>
  )
}

ArgosHeader.propTypes = propTypes
ArgosHeader.defaultProps = defaultProps

export default ArgosHeader
export { ArgosHeader }
